import*as o from"./_node-resolve_empty.js";import{getAugmentedNamespace as e}from"./_commonjsHelpers.js";var r=e(o);export{r as default};
//# sourceMappingURL=__node-resolve_empty.js.map
